<template>
  <!-- ZN -->
  <div v-if="el === 'zn'" class="el el-zn" :class="{ 'el-lg': large }">
    <span>30</span>
    <p>Zn</p>
    <span>65.38</span>
  </div>
  <!-- PB -->
  <div v-else-if="el === 'pb'" class="el el-pb" :class="{ 'el-lg': large }">
    <span>82</span>
    <p>Pb</p>
    <span>207.2</span>
  </div>
  <!-- CD -->
  <div v-else-if="el === 'cd'" class="el el-cd" :class="{ 'el-lg': large }">
    <span>48</span>
    <p>Cd</p>
    <span>112.41</span>
  </div>
  <!-- AG -->
  <div v-else-if="el === 'ag'" class="el el-ag" :class="{ 'el-lg': large }">
    <span>47</span>
    <p>Ag</p>
    <span>107.868</span>
  </div>
  <!-- AU -->
  <div v-else-if="el === 'au'" class="el el-au" :class="{ 'el-lg': large }">
    <span>79</span>
    <p>Au</p>
    <span>196.96657</span>
  </div>
  <!-- CH -->
  <div v-else-if="el === 'ch'" class="el el-ch" :class="{ 'el-lg': large }">
    <p class="ch-letters">
      H
      <span>2</span>SO
      <span>4</span>
    </p>
    <!-- <span>196.96657</span> -->
  </div>
</template>

<script>
export default {
  props: ["el", "large"]
};
</script>

<style lang="scss" scoped>
.el {
  @extend %flex-center;
  flex-direction: column;
  justify-content: space-between;
  height: 55px;
  margin-left: 10px;
  padding: 6px;
  position: relative;
  width: 55px;

  // element sign
  span:first-child {
    display: inline-block;
    font-size: 8px;
    text-align: right;
    width: 100%;
  }

  p {
    font-size: 28px;
    line-height: 28px;
    font-weight: 700;
  }

  span:last-child {
    display: inline-block;
    font-size: 8px;
    width: 100%;
  }
}

.el-lg {
  height: $chemicalLarge;
  padding: 15px 15px;
  width: $chemicalLarge;
  span:nth-child(1n) {
    font-size: 20px;
  }
  p {
    font-size: 100px;
    font-weight: 500;
  }
}

.el::before {
  border: 1px solid $mainTextLight;
  content: "";
  height: calc(100% - 4px);
  position: absolute;
  top: 2px;
  left: 2px;
  width: calc(100% - 4px);
}

.el-zn {
  background-color: $znLight;
  color: $znDark;
}
.el-zn::before {
  border-color: $znDark;
}

.el-pb {
  background-color: $pbLight;
  color: $pbDark;
}
.el-pb::before {
  border-color: $pbDark;
}

.el-cd {
  background-color: $cdLight;
  color: $cdDark;
}
.el-cd::before {
  border-color: $cdDark;
}

.el-ag {
  background-color: $agLight;
  color: $agDark;
}
.el-ag::before {
  border-color: $agDark;
}

.el-au {
  background-color: $auLight;
  color: $auDark;
}
.el-au::before {
  border-color: $auDark;
}

.el-ch {
  background-color: #c5d1e7;
  color: #4168b1;
  justify-content: center;
  .ch-letters {
    align-items: flex-end;
    display: flex;
    justify-content: center;
    font-size: 52px;
    line-height: 52px;
    font-weight: 700;
    white-space: nowrap;
    span {
      display: flex;
      height: 20px;
      font-size: 20px;
      line-height: 20px;
    }
  }
}
.el-ch::before {
  border-color: #4168b1;
}

@media screen and (max-width: 1440px) {
  .el-lg {
    height: $chemicalLarge1440;
    padding: 15px 15px;
    width: $chemicalLarge1440;
    span:nth-child(1n) {
      font-size: 14px;
    }
    p {
      font-size: 72px;
      line-height: 60px;
    }
  }
  .el-ch {
    .ch-letters {
      font-size: 36px;
      line-height: 36px;

      span {
        height: 18px;
        font-size: 18px;
        line-height: 18px;
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .el {
    height: 50px;
    width: 50px;
    span:nth-child(1n) {
      font-size: 7px;
    }
    p {
      font-size: 22px;
      line-height: 20px;
    }
  }
  .el-lg {
    height: $chemicalLarge1440;
    width: $chemicalLarge1440;
    span:nth-child(1n) {
      font-size: 14px;
    }
    p {
      font-size: 72px;
      line-height: 60px;
    }
  }
}
@media screen and (max-width: 600px) {
  .el-lg {
    height: $chemicalLarge600;
    padding: 10px;
    width: $chemicalLarge600;
    span:nth-child(1n) {
      font-size: 10px;
      line-height: 10px;
    }
    p {
      font-size: 42px;
      line-height: 40px;
    }
  }
  .el-ch {
    .ch-letters {
      font-size: 20px;
      line-height: 20px;

      span {
        height: 12px;
        font-size: 12px;
        line-height: 12px;
      }
    }
  }
}
@media screen and (max-width: 420px) {
  .el {
    height: 40px;
    width: 40px;
    span:nth-child(1n) {
      font-size: 5px;
    }
    p {
      font-size: 18px;
      line-height: 20px;
    }
  }
  .el-lg {
    height: $chemicalLarge600;
    padding: 10px;
    width: $chemicalLarge600;
    span:nth-child(1n) {
      font-size: 10px;
      line-height: 10px;
    }
    p {
      font-size: 42px;
      line-height: 40px;
    }
  }
}
</style>

